import Block from './Block'
import InterestForm from './SingleProperty/InterestForm'
import PropertyVisning from './SingleProperty/PropertyVisning'
import PropertyRouteMap from "./SingleProperty/PropertyRouteMap"
import Modal from "../modal"

export default class SingleProperty extends Block {
    constructor(blockRoot) {
        super(blockRoot)

        this.is = {
            projekt: this.root.hasClass('proptype-projekt'),
            objekt: this.root.hasClass('proptype-objekt'),
        }

        this.images = JSON.parse(this.root.find('.property-images').text())
        this.header = $('#site-header')
        this.buttons = {
            gallery: this.root.find('.property-gallery-button'),
            contact: this.root.find('.contact-link-anchor'),
        }
        this.imagesArr = []
        this.icons = this.root.find('.prop-splash__icon')

        this.interestForm = new InterestForm(this.root.find('.interest-button'), this.is)
        this.visning = new PropertyVisning(this.root.find('.visning'))
        this.routeMap = new PropertyRouteMap(this.root.find('.property-route-map'))

        // var other = ".intro, .info, .om, .detaljer, .karta, .lagenheter".split(", ");
        let other = '.prop-splash, .prop-split-info, .property-details.container, .property-route-map, .objektlista, .projektList, .property-status-list'.split(', ')
        other.map(selector => new Block(this.root.find(selector)))

        let propViz = this.root.find('.propViz')

        if (propViz.length > 0) {
            propViz.each((i, viz) => {
                let $viz = $(viz)
                $viz.lightGallery({
                    iframeMaxWidth: '100%',
                    selector: '.propViz__link',
                })

                $viz.on('onAferAppendSlide.lg', event => {
                    let frame = $('iframe.lg-object')
                    let toolbar = $('.lg-toolbar.group')
                    frame.parent().get(0).style.setProperty('height', '100vh', 'important')
                    frame.parent().get(0).style.setProperty('padding', '0', 'important')
                    frame.get(0).style.setProperty('height', '100vh', 'important')
                    let update = function() {
                        frame.get(0).style.setProperty('padding-top', toolbar.height() + 'px', 'important')
                    }
                    update()
                    $(window).on('resize orientationchange', update.bind(this))
                })
            })
        }

        if (this.images.length > 0) {
            this.images.forEach(item => {
                this.imagesArr.push({
                    'src': item
                })
            })
        }

        if (this.icons.length) {
            this.icons.each((i, icon) => {
                let modal = new Modal()
                modal.defineContent($(icon).find('.prop-splash__icon-content').clone())

                $(icon).on('click', () => {
                    modal.show()
                })
            })
        }


        this.buttons.gallery.each((i, button) => {
            $(button).on('click', () => {
                $(button).lightGallery({
                    dynamic: true,
                    dynamicEl: this.imagesArr
                })
            })
        })

        this.buttons.contact.on('click', (event) => {
            event.preventDefault()
            let section = $('.prop-contact')

            $('html, body').animate({
                scrollTop: section.offset().top - this.header.outerHeight() - 20,
            })
        })
    }
}

